export const locationOffersDelivery = (location) => {
    const flag = location?.merchant?.offer_delivery ?? location?.offer_delivery;
    return flag == 1 || flag === true;
};

export const callApiUrl = (method, url, data) => {  
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(method, url);
        xhr.onload = function () {
          if (this.status >= 200 && this.status < 300) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject({
              status: this.status,
              statusText: xhr.statusText
            });
          }
        };
        xhr.onerror = function () {
          reject({
            status: this.status,
            statusText: xhr.statusText
          });
        };
        xhr.send(JSON.stringify(data));
      });
}